module.exports = __webpack_public_path__ + "img/bulb.669e9360.svg";